//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import webinarQuery from '~/apollo/queries/webinars/webinar-slug'

export default {
  mixins: [seo],
  data () {
    return {
      fetched: false
    }
  },
  apollo: {
    webinars: {
      prefetch: true,
      query: webinarQuery,
      variables () {
        return { slug: this.$route.params.slug }
      },
      result ({ data, loading, networkStatus }) {
        if (data.webinars && data.webinars.data && data.webinars.data.length > 0) {
          this.seoTitle = data.webinars.data[0].attributes.title
        }
        this.fetched = true
      },
      error (error) {
        console.log(error)
        this.fetched = true
      }
    }
  }
}

